export default __webpack_public_path__ + "static/media/tiktok.1ee04b23.jpeg";